import { koComponent } from '../../../ko-utils/index';
import * as siteConfig from '../../../site-config/config';
import createUuid from '../../../utils/uuid';
import tryMakeUrlDynamic from '../../../utils/tryMakeUrlDynamic';
import CardEditorBase from '../../../common/card-editor/CardEditorBase';
import { isFlagOn } from '../../../utils/flags';

class CardEditor extends CardEditorBase {
    constructor(params) {
        super('card');

        this.parent = params.parent;
        this.card = ko.unwrap(params.card);

        const isCardsObjSet = () => {
            return this.parent &&
                ko.isObservable(this.parent.tour) &&
                this.parent.tour() &&
                ko.isObservable(this.parent.tour().descriptorObject) &&
                this.parent.tour().descriptorObject() &&
                ko.isObservable(this.parent.tour().descriptorObject().cards) &&
                this.parent.tour().descriptorObject().cards();
        }

        this.cardOrder = ko.computed(() => {
            if (isCardsObjSet()) {
                return this.parent.tour().descriptorObject().cards().indexOf(this.card);
            } else {
                return -1;
            }
        });

        this.cardsCount = ko.computed(() => {
            if (isCardsObjSet()) {
                return this.parent.tour().descriptorObject().cards().length;
            } else {
                return 0;
            }
        });

        this.isLastCard = ko.computed(() => {
            return this.cardOrder() == this.cardsCount() - 1;
        });

        this.hasSkipOnLastCardFlag = ko.pureComputed(() => {
            return isFlagOn('skip_on_last');
        })

        this.hasMaxHeight = ko.pureComputed(() => {
            return isFlagOn('tr_mx_hght');
        })

        this.isSelected = ko.observable(params.isSelected || false);
        this.isSelected.subscribe(val => {
            if (val) {
                params.parent.setSelectedCard(this);
            } else {
                params.parent.setSelectedCard(null);
            }
        });

        let isNew = false;

        if (!this.card.id || !this.card.id()) {
            this.card.id(createUuid());

            isNew = true;
        }

        if (this.card.url()) {
            this.initAutosaveHandlers(this.card.url(), ['parametrized'])
        }

        if (!this.card.backdrop()) {
            this.card.backdrop(new siteConfig.BackdropDescriptor());
        }

        this.card.backdrop().type.subscribe(() => {
            this.changeCardProps();
            this.autosave();
        });

        if (!this.card.displayType()) {
            this.card.displayType('element');
        }

        if (this.card.displayType() === 'element') {
            if (!this.card.elements() || !this.card.elements()[0]) {
                this.card.elements.push(new siteConfig.ElementDescriptor());
            }

            this.card.elements()[0].query.subscribe(() => {
                this.showCardInWeb();
                this.autosave();
            });
        }

        this.listenToThisId('cardElementQueried', this.card.id(), data => {
            if (isFlagOn('iframes')) {
                if (!ko.isObservable(this.card.elements()[0].iframe) && data.detail.iframe) {
                    this.card.elements()[0].iframe = ko.observable();
                }

                this.card.elements()[0].iframe(data.detail.iframe);
            }

            this.card.elements()[0].query(data.detail.query);

            var sv = new siteConfig.StringValue();
            sv.parametrized(tryMakeUrlDynamic(data.detail.url, this.parent.editorSettings.dontDetectDynamicUrlParts()));

            this.card.url(sv);
            this.initAutosaveHandlers(this.card.url(), ['parametrized'])
            this.autosave();
        });
        this.listenToThisId('cardSelectorChanged', this.card.id(), data => {
            if (isFlagOn('iframes')) {
                if (!ko.isObservable(this.card.elements()[0].iframe) && data.detail.iframe) {
                    this.card.elements()[0].iframe = ko.observable();
                }

                this.card.elements()[0].iframe(data.detail.iframe);
            }

            this.card.elements()[0].query(data.detail.query);

            this.autosave();
        });

        this.listenToThisId('cardContentSet', this.card.id(), data => {
            //this.isSelected(false);

            this.card.content(new siteConfig.CardContentDescriptor(data.detail.content));
        });

        this.listenToThisId('envInfoResponse', this.card.id(), data => {
            var sv = new siteConfig.StringValue();
            sv.parametrized(tryMakeUrlDynamic(data.detail.urlPath, this.parent.editorSettings.dontDetectDynamicUrlParts()));
            this.card.url(sv);
            this.initAutosaveHandlers(this.card.url(), ['parametrized'])
            this.autosave();
        });

        this.listenToThisId('deselectCard', this.card.id(), data => {
            this.isSelected(false);
        });

        this.listenToThisId('selectCard', this.card.id(), data => {
            this.showCardInWeb();
        });

        this.listenToThisId('relocateCard', this.card.id(), data => {
            this.locateElement();
        });

        this.listenToThisIdOnce('closeCard', this.card.id(), data => {
            window.parent.postMessage({ action: 'close-card', cardId: this.card.id() }, '*');
        });

        this.listenToThisId('cardResumeEditing', this.card.id(), data => {
            this.showCardInWeb();
        });

        this.hasElementsSelected = ko.pureComputed(() => {
            if (this.card.elements() && this.card.elements()[0]) {
                return ko.unwrap(this.card.elements()[0].query) != null || ko.unwrap(this.card.elements()[0].id) != null;
            } else {
                return false;
            }
        });

        if (isNew) {
            if (this.card.displayType() === 'dialog') {
                this.getEnvInfo();
                this.showCardInWeb();
            } else {
                this.locateElement();
            }
        }

        this.backdropTypesByCardType = ko.pureComputed(() => {
            if (this.card.displayType() == 'element') {
                return [undefined, 'blocking', 'boxed_noblock', 'boxed', 'boxed_bg', 'glow', 'glow_block'];
            } else {
                return [undefined, 'blocking', 'transparent', 'solid'];
            }
        });

        //this.skipButtonTypes = [
        //    { text: 'Footer', value: undefined },
        //    { text: 'Top corner close', value: '' }
        //    { text: 'Top corner close', value: '' },
        //];

        this.headerVisible = ko.observable(this.getVisibilityPropSafe('title'));
        this.headerVisible.subscribe(() => {
            this.headerFooterVisibilityChanged();
        });
        this.footerVisible = ko.observable(this.getVisibilityPropSafe('footer'));
        this.footerVisible.subscribe(() => {
            this.headerFooterVisibilityChanged();
        });
        this.nextButtonVisible = ko.observable(this.getFooterButtonVisibilityPropSafe('nextButton'));
        this.nextButtonVisible.subscribe(() => {
            this.headerFooterVisibilityChanged();
        });
        this.backButtonVisible = ko.observable(this.getFooterButtonVisibilityPropSafe('backButton', false));
        this.backButtonVisible.subscribe(() => {
            this.headerFooterVisibilityChanged();
        });
        this.skipButtonVisible = ko.observable(this.getFooterButtonVisibilityPropSafe('skipButton'));
        this.skipButtonVisible.subscribe(() => {
            this.headerFooterVisibilityChanged();
        });

        this.initAutosaveHandlers(this.card, ['blockedKeys', 'showDelayMs', 'advanceOnRemove', 'advanceOnHide', 'pauseTillReload', 'advanceIfElMissing', 'advanceIfElMissingDelay']);
    }

    get currentSelectorObservable() {
        if (this.card.elements() && this.card.elements()[0]) {
            return this.card.elements()[0].query;
        }
    }

    findParentElement() {
        window.parent.postMessage({
            action: 'select-parent-element',
            cardId: ko.unwrap(this.card.id),
            selector: ko.unwrap(this.card.elements()[0].query),
            selectorSettings: this.parent.editorSettings.toJS()
        }, '*');
    }

    initAutosaveHandlers(baseObject, props) {
        const subscribeAndNotify = (prop) => {
            if (baseObject && baseObject[prop] && baseObject[prop].subscribe) {
                baseObject[prop].subscribe((val) => {
                    this.autosave();
                });
            }
        };

        Array.from(props).forEach(p => subscribeAndNotify(p));
        //subscribeAndNotify('blockedKeys');
        //subscribeAndNotify('showDelayMs');
    }

    onAdvanceActionChanged(action, opts) {
        if (!!action) {
            if (action == 'oninput' && opts && opts.oninput == 'disabled') {
                this.nextButtonVisible(true);
                this.footerVisible(true);
            } else {
                this.nextButtonVisible(false);
                if (!this.skipButtonVisible() && !this.backButtonVisible()) {
                    this.footerVisible(false);
                }
            }
        } else {
            this.nextButtonVisible(true);
            this.footerVisible(true);
        }
    }

    showHelp(id) {
        window.parent.postMessage({
            action: 'pf_show_help',
            id
        }, '*');
    }

    getFooterButtonVisibilityPropSafe(btnName, defIfNotExists = true) {
        const cont = ko.unwrap(this.card.content);
        const footer = ko.unwrap(cont.footer);
        if (!footer) return defIfNotExists;

        if (defIfNotExists) {
            return ko.unwrap(footer[btnName].visible) !== false;
        } else {
            return ko.unwrap(footer[btnName].visible) === true;
        }
    }

    getVisibilityPropSafe(prop) {
        const cont = ko.unwrap(this.card.content);
        const p = ko.unwrap(cont[prop]);
        return ko.unwrap(p.visible);
    }

    headerFooterVisibilityChanged() {
        window.parent.postMessage({
            action: 'changeHeaderFooter',
            headerVisibility: this.headerVisible(),
            footerVisibility: this.footerVisible(),
            nextButtonVisibility: this.nextButtonVisible(),
            backButtonVisibility: this.backButtonVisible(),
            skipButtonVisibility: this.skipButtonVisible()
        }, '*');
        this.autosave();
    }

    positionPropChanged(propName) {
        this.changeCardProps();
        this.autosave();
    }

    locateElement() {
        this.isSelected(true);
        window.parent.postMessage({ action: 'locateElement', cardId: this.card.id(), cardJson: JSON.parse(JSON.stringify(this.card.toJS())), selectorSettings: this.parent.editorSettings.toJS(), language: this.parent.selectedLanguage() }, '*');
    }

    changeCardProps() {
        window.parent.postMessage({ action: 'changeProps', cardId: this.card.id(), cardJson: JSON.parse(JSON.stringify(this.card.toJS())), language: this.parent.selectedLanguage() }, '*');
    }

    showCardInWeb() {
        this.isSelected(true);
        window.parent.postMessage({ action: 'showCard', cardId: this.card.id(), cardJson: JSON.parse(JSON.stringify(this.card.toJS())), language: this.parent.selectedLanguage() }, '*');
    }

    getEnvInfo() {
        window.parent.postMessage({ action: 'envInfo', cardId: this.card.id() }, '*');
    }

    autosave() {
        this.parent.autosave();
    }
}


export default koComponent('card-editor', CardEditor);